module.exports = __webpack_public_path__ + "media/sample-0.6ba2e139.mp3";